    async function addRemoveFavoritos(product, button) {
      console.log('addRemoveFavoritos');
      button.disabled = true;
      var bodyData = JSON.stringify({
        shop: Shopify.shop,
        customerid: __st.cid,
        productid: parseInt(product),
      });
  
      const fetchOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: bodyData,
      };
  
      const response = await fetch('/apps/upango-favoritos/customers/favoritos/', fetchOptions);
      if (response.ok) {
        const jsonData = await response.json();
        console.log('resultado: ' + JSON.stringify(jsonData));
        button.disabled = false;
        button.classList.add('no-hover');

        if (jsonData.data.favoritos.activo == 1) {
          button.classList.remove('btn-fav-inactivo');
          button.classList.add('btn-fav-activo');
        } else {
          button.classList.remove('btn-fav-activo');
          button.classList.add('btn-fav-inactivo');
        }
          button.addEventListener('mouseout', () => {
            button.classList.remove('no-hover');
          });
      }
    }